import React from 'react'
import styled, { keyframes } from 'styled-components';

const DotsWrapper = styled.div`
  display: flex;
  gap: 4px;
  justify-content: center;

  div {
    width: 12px;
    height: 12px;
    background-color: ${(props) => props.theme.colors.secondary};
    border-radius: 50%;
    animation: ${keyframes`
      0%, 80%, 100% { transform: scale(0); }
      40% { transform: scale(1); }
    `} 1.4s infinite ease-in-out;
  }

  div:nth-child(1) { animation-delay: 0s; }
  div:nth-child(2) { animation-delay: 0.2s; }
  div:nth-child(3) { animation-delay: 0.4s; }
`;

const LoadingDots = () => {
  return (
    <DotsWrapper>
      <div></div>
      <div></div>
      <div></div>
    </DotsWrapper>
  )
}

export default LoadingDots
